const state = {
  produtosSelecionados: [],
  pautaSelecionada: {},
  produtosReferenciacao: [],
};

export default state;
